module.exports = __webpack_public_path__ + "img/device_1014_2_select.3559ad1e.svg";